export interface ReturnBorrowCollectionCheckRequest {
  collectionId: number
  collectionNo: string
}

export function ReturnBorrowCollectionCheckRequestToJSON(
  value: ReturnBorrowCollectionCheckRequest
): any {
  return {
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined
  }
}
